import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import PartnersAPI from '../../api/partners';
import { extractRecord, extractList } from '../utils/appointmentEnvelope';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isFetchError: false,
  },
};

export const getters = {
  getPartners(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getPartnerById: _state => id => {
    return _state.records.find(record => record.id === Number(id)) || {};
  },
};

export const actions = {
  get: async function getPartners({ commit }) {
    commit(types.SET_PARTNER_UI_FLAG, {
      isFetching: true,
      isFetchError: false,
    });
    try {
      const response = await PartnersAPI.get();
      commit(types.SET_PARTNERS, extractList(response));
    } catch {
      commit(types.SET_PARTNER_UI_FLAG, { isFetchError: true });
    } finally {
      commit(types.SET_PARTNER_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createPartner({ commit }, partnerData) {
    commit(types.SET_PARTNER_UI_FLAG, { isCreating: true });
    try {
      const response = await PartnersAPI.create(partnerData);
      commit(types.ADD_PARTNER, extractRecord(response));
      return extractRecord(response);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_PARTNER_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updatePartner({ commit }, { id, ...updateData }) {
    commit(types.SET_PARTNER_UI_FLAG, { isUpdating: true });
    try {
      const response = await PartnersAPI.update(id, updateData);
      commit(types.EDIT_PARTNER, extractRecord(response));
      return extractRecord(response);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_PARTNER_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deletePartner({ commit }, id) {
    commit(types.SET_PARTNER_UI_FLAG, { isDeleting: true });
    try {
      await PartnersAPI.delete(id);
      commit(types.DELETE_PARTNER, id);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_PARTNER_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_PARTNER_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_PARTNERS]: MutationHelpers.set,
  [types.ADD_PARTNER]: MutationHelpers.create,
  [types.EDIT_PARTNER]: MutationHelpers.update,
  [types.DELETE_PARTNER]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
